export const EMAIL_VALIDATION_BASE_URL = 'https://services.postcodeanywhere.co.uk/';
export const EMAIL_VALIDATION_URL = 'EmailValidation/Interactive/Validate/v2.00/json3.ws';
